<template>

</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    props: ['show_notificate_users', 'id', 'title'],

    data() {
        return {

        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        show_report: {
            get() {
                return this.show_notificate_users
            },
            set() {
                this.$emit('hide_notificate_users', '')
            }
        },
    },

    watch: {
        show_notificate_users: function() {
            if (this.show_notificate_users) {
                this.requestStars()
            }
        }
    },
}
</script>

<style>

</style>
